import ReactDOM from 'react-dom/client';

import '@/_shared/css/style.css';
import EntryPoint from './entry-point';

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <StrictMode>
  <EntryPoint />
  // {/* </StrictMode> */}
);
